import { UserWithClients } from "../context/ClientAccessContext/types";
import { Topic, UserRole } from "../context/ConfigContext/types";
import { Document } from "../types";

export enum RequestType {
	GET = "get",
	POST = "post",
	PUT = "put",
	PATCH = "patch",
	DELETE = "delete",
}

export interface EmbedReport {
	reportId: string;
	reportName: string;
	embedUrl: string;
}

export interface EmbedToken {
	expiration: string;
	token: string;
	tokenId: string;
}

export interface EmbedParams {
	type: string;
	embedReport: EmbedReport[];
	embedToken: EmbedToken;
}

export interface FetchResponse<T> {
	statusCode: number;
	isSuccess: boolean;
	errorMessages: string[];
	result: T;
	totalPages?: T extends Document ? number : never;
	languages?: T extends Document ? string[] : never;
}

export interface FetchTopicAccessResult {
	clientId: number;
	role: UserRole;
	topics: Topic[];
}

export interface DeleteAllFeedbacksBody {
	labelId: number;
	documentId: number;
}

export interface CreateLabelValueBody {
	labelId: number;
	value: string;
}

export interface CreateOrUpdateOptionValue {
	value: string;
	configId: number;
	configOptionName: string;
	active: boolean;
}

export interface CreateOrUpdateConfigBody {
	name: string;
	scraperId: number;
	topicId: number;
	active: boolean;
}

export interface CreateMainUserResponse {
	mainDb: {
		createdMainUserId: number;
		createdClientAccessIds: number[];
	};
	clientResults: {
		clientId: number;
		createdClientUserId: number;
		createdTopicAccessIds: number[];
	}[];
	errors: string[];
}

export interface UpdateMainUserResponse {
	user: UserWithClients;
	createUserResponse?: CreateMainUserResponse;
}

export interface WizardInput {
	clientName: string;
	topicName: string;
	requestType: string;
	promptData: { userMessage: string };
}

export interface WizardOutput {
	data: string[];
	message: string;
	success: boolean;
}

export enum Endpoint {
	WIZARD = "wizard",
	DOCUMENTS = "Documents",

	MAIN_USERS = "mainUsers",
	USER_CLIENT_ACCESS = "mainUsers/client_accesses",
	All_USERS_CLIENTS = "mainUsers/all/withClients",

	CLIENT_USERS = "clientUsers",
	USER_TOPIC_ACCESS = "clientUsers/topic_accesses",
	All_USERS_TOPICS = "clientUsers/all/withTopics",

	USER_FEEDBACK = "UserFeedback",
	TOPICS = "Topics",

	LABELS = "Labels",
	LABEL_VALUES = "labelValues",

	CONFIG_OPTION_VALUE = "configOptionValues",
	CONFIG = "config",
	SCRAPERS = "scrapers",
	CLIENTS = "clients",
	EMBED_REPORT = "embedconfig",
	SEND_NEWSLETTER = "newsletter/send",
}

export enum EndpointsWithActiveFlag {
	LABELS = Endpoint.LABELS,
	LABEL_VALUES = Endpoint.LABEL_VALUES,
	CONFIG = Endpoint.CONFIG,
	CONFIG_OPTION_VALUE = Endpoint.CONFIG_OPTION_VALUE,
}

export interface SearchQuery {
	topicId?: number;
	includeText?: string;
	excludeText?: string;
	includeDocuments?: Document[];
	excludeDocuments?: Document[];
}
